export enum ExportTag {
  INTERNAL = 'INTERNAL',
  EXPORT_REQUESTS_DETAIL = 'EXPORT_REQUESTS_DETAIL',
  EXPORT_REQUESTS_GRID = 'EXPORT_REQUESTS_GRID',
  EXPORT_TEMPLATES_DETAIL = 'EXPORT_TEMPLATES_DETAIL',
  EXPORT_TEMPLATES_GRID = 'EXPORT_TEMPLATES_GRID',
  SCHEDULE_JOBS_DETAIL = 'SCHEDULE_JOBS_DETAIL',
  SCHEDULE_JOBS_GRID = 'SCHEDULE_JOBS_GRID',
  ALOG_GRID = 'ALOG_GRID',
  /*   SCHEDULE_RUNS_DETAIL = 'SCHEDULE_RUNS_DETAIL',
  SCHEDULE_RUNS_GRID = 'SCHEDULE_RUNS_GRID', */

  IMPORT_REQUEST_GRID = 'IMPORT_REQUEST_GRID',
  NON_STANDARD_STATE_GRID = 'NON_STANDARD_STATE_GRID',
  IP_ENTRY_GRID = 'IP_ENTRY_GRID',
  PARAGRAPH_GRID = 'PARAGRAPH_GRID',
  RESEARCH_QUERY_GRID = 'RESEARCH_QUERY_GRID',
  USER_GRID = 'USER_GRID',
  SYSTEM_USER_GRID = 'SYSTEM_USER_GRID',
}
